<template>
  <div class="policy-page">
    <WeCircularNavbar @go-home="$emit('go-home')" @go-countries="$emit('go-countries')" />

    <main class="policy-page__container">
      <button class="back-button" type="button" @click="$router.back()">
        ← Back
      </button>

      <section class="policy-hero">
        <div class="policy-hero__content">
          <h1 class="policy-title">
            European Policies and
            <br />
            Strategies
          </h1>

          <h2 class="policy-subtitle">Digitalization</h2>

          <p class="policy-intro">
            Discover key EU strategies accelerating digital transformation, innovation and competitiveness across
            sectors.
          </p>
        </div>
      </section>

      <section class="cards-section">
        <div class="cards-grid cards-grid--two">
          <article class="info-card">
            <div class="card-header"></div>

            <div class="card-body">
              <div class="card-icon">
                <img :src="cloudIcon" alt="Shaping Europe’s digital future" />
              </div>

              <h3 class="card-title">Shaping Europe’s digital future</h3>

              <p class="card-text">
                The Digital Package - Streamlining EU digital rules to make compliance easier for EU businesses and
                boost innovation
              </p>

              <a
                href="https://digital-strategy.ec.europa.eu/en/library?type=25"
                target="_blank"
                rel="noopener noreferrer"
                class="learn-more"
              >
                Learn More
                <span aria-hidden="true">→</span>
              </a>
            </div>
          </article>

          <article class="info-card">
            <div class="card-header"></div>

            <div class="card-body">
              <div class="card-icon">
                <img :src="monitorIcon" alt="Digitalization of SMEs" />
              </div>

              <h3 class="card-title">Digitalization of SMEs</h3>

              <p class="card-text">
                Let’s dive into the most recent collection of OECD reports in connection with digitalization of SMEs
              </p>

              <a
                href="https://www.oecd.org/en/search/publications.html?facetTags=oecd-policy-subissues%3Apsi105%2Coecd-content-types%3Apublications%2Freports%2Coecd-content-types%3Apublications%2Fpolicy-briefs%2Coecd-content-types%3Apublications%2Fpolicy-papers%2Coecd-content-types%3Apublications%2Fworking-papers%2Coecd-content-types%3Apublications%2Fstandards-and-guidelines%2Coecd-languages%3Aen&path=%2Fcontent%2Foecd%2Fen%2Fpublications&orderBy=mostRelevant&page=0"
                target="_blank"
                rel="noopener noreferrer"
                class="learn-more"
              >
                Learn More
                <span aria-hidden="true">→</span>
              </a>
            </div>
          </article>
        </div>
      </section>
    </main>

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'

import cloudIcon from '../../assets/img/we-circular/Stats/Cloud.svg'
import monitorIcon from '../../assets/img/we-circular/Stats/Monitor.svg'

export default {
  name: 'DigitalizationPage',
  components: {
    WeCircularNavbar,
    WeCircularFooter
  },
  emits: ['go-home', 'go-countries'],
  data() {
    return {
      cloudIcon,
      monitorIcon
    }
  }
}
</script>

<style scoped>
.policy-page {
  min-height: 100vh;
  background: #f3f3f3;
  padding: 22px 0 64px;
}

.policy-page__container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 38px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 5vw;
}

.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  align-self: flex-start;
  height: 30px;
  min-width: 66px;
  padding: 0 12px;
  margin: 0 0 22px 0;
  border: 1px solid #003399;
  border-radius: 8px;
  background: transparent;
  color: #003399;
  line-height: 1;
  cursor: pointer;
}

.policy-hero {
  margin-bottom: 24px;
}

.policy-hero__content {
  max-width: 580px;
  text-align: left;
}

.policy-title {
  margin: 0;
  max-width: 520px;
  color: #003399;
  line-height: 1.02;
  font-weight: 600;
  letter-spacing: -0.03em;
  text-align: left;
}

.policy-subtitle {
  margin: 26px 0 0;
  color: #003399;
  line-height: 1.08;
  font-weight: 600;
  text-align: left;
}

.policy-intro {
  max-width: 255px;
  margin: 14px 0 34px;
  color: #0e6eb6;
  line-height: 1.45;
  text-align: left;
}

.cards-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 0;
}
.cards-grid {
  display: grid;
  gap: 24px;
}

.cards-grid--two {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.info-card {
  background: #f7f7f7;
  border: 1px solid #1d6b6b;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 236px;
  box-sizing: border-box;
}

.card-header {
  height: 84px;
  background: #004444;
  background-image: url('../../assets/img/we-circular/9-16@4x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.card-body {
  position: relative;
  padding: 26px 22px 18px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.card-icon {
  width: 44px;
  height: 44px;
  border-radius: 9px;
  background: #0e6eb6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -48px auto 16px;
  box-shadow: 0 6px 16px rgba(14, 110, 182, 0.2);
}

.card-icon img {
  width: 22px;
  height: 22px;
  display: block;
}

.card-title {
  margin: 0 0 10px;
  max-width: 260px;
  color: #003399;
  line-height: 1.3;
  font-weight: 700;
  text-align: center;
}

.card-text {
  margin: 0;
  max-width: 280px;
  color: #4f5f78;
  line-height: 1.5;
  text-align: center;
}

.learn-more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: auto;
  padding-top: 14px;
  color: #18baa8;
  text-decoration: none;
  font-weight: 700;
  line-height: 1.2;
}

.learn-more:hover {
  text-decoration: underline;
}

@media (max-width: 1100px) {
  .policy-page__container {
    max-width: 92%;
    padding: 0 20px;
  }

  .policy-intro {
    max-width: 320px;
  }
}

@media (max-width: 900px) {
  .policy-title {
    font-size: 34px;
  }

  .policy-subtitle {
    font-size: 24px;
  }

  .policy-intro {
    max-width: 100%;
  }

  .cards-grid--two {
    grid-template-columns: 1fr;
    max-width: 100%;
  }

  .info-card {
    min-height: 220px;
  }
}

@media (max-width: 480px) {
  .policy-page {
    padding-bottom: 48px;
  }

  .policy-title {
    font-size: 26px;
  }

  .policy-subtitle {
    font-size: 20px;
  }

  .policy-intro {
    font-size: 12px;
  }

  .card-body {
    padding: 24px 16px 16px;
  }

  .card-title {
    font-size: 13px;
  }

  .card-text {
    font-size: 11px;
  }
}
</style>
